/** Layers that own the keyboard while open: menus, selects, popovers, dialogs. */
const OVERLAY_LAYER_SELECTOR = '[data-radix-popper-content-wrapper], [role="menu"], [role="listbox"], [role="dialog"]'

/** Content of ui/dialog and ui/sheet. Popovers also carry role="dialog", so match the slot, not the role. */
export const MODAL_CONTENT_SELECTOR = '[data-slot="dialog-content"], [data-slot="sheet-content"]'

export const OPEN_MODAL_SELECTOR =
	'[data-slot="dialog-content"][data-state="open"], [data-slot="sheet-content"][data-state="open"]'

/** Transient layers only. A dialog is the user's current task and is never dismissed from here. */
const DISMISSABLE_LAYER_SELECTOR = '[data-radix-popper-content-wrapper], [role="menu"], [role="listbox"]'

/**
 * A Radix layer owns the keyboard while it is open. Window-level shortcuts must skip those keys:
 * Radix handles them from its own listener, so a shortcut that acts anyway leaves the layer floating
 * over whatever it just changed.
 */
export function isInOverlayLayer(target: EventTarget | null): boolean {
	if (!(target instanceof HTMLElement)) {
		return false
	}
	return target.closest(OVERLAY_LAYER_SELECTOR) !== null
}

/**
 * Closes the topmost open menu or listbox. Dispatches the Escape its dismissable layer listens for,
 * since the layer is portaled to the body and outlives the collapse of whatever opened it.
 *
 * Silent while a dialog is open: Escape reaches every document listener, and a modal dialog is the
 * user's current task, never something to close as a side effect.
 */
export function dismissOverlayLayers(): void {
	if (isModalOpen()) {
		return
	}
	if (!document.querySelector(DISMISSABLE_LAYER_SELECTOR)) {
		return
	}
	document.dispatchEvent(new KeyboardEvent('keydown', { key: 'Escape', bubbles: true }))
}

export function isModalOpen(): boolean {
	return document.querySelector(OPEN_MODAL_SELECTOR) !== null
}
